// HANDLE PAYMENT

import PaystackPop from '@paystack/inline-js';
import axios from 'axios';

export async function handlePayment(userEmail, amount, accessToken) {
    try {
      // 1. Initialize transaction on backend
      const { data } = await axios.post(
        '/user/initialize-subscription',
        {
          email: userEmail,
          amount: amount * 100, // optional, Paystack uses plan amount by default
          plan: process.env.REACT_APP_PLAN_CODE,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
  
      const { authorization_url, reference } = data;
  
      // 2. Open Paystack payment popup
      const paystack = new PaystackPop();
  
      paystack.newTransaction({
        key: process.env.REACT_APP_PAYSTACK_PUBLIC_KEY,
        email: userEmail,
        reference: reference,
        amount: amount * 100, // optional if plan is set
        onSuccess: (transaction) => {
          console.log('Subscription successful:', transaction);
          alert('Subscription successful! You are now a premium user.');
          // Redirect or update UI
          window.location.href = '/dashboard/alreadysubscribed';
        },
        onCancel: () => {
          console.log('Payment canceled');
          alert('Payment canceled');
        },
        onError: (error) => {
          console.error('Payment error:', error.message);
          alert('Payment error: ' + error.message);
        },
      });
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.error || 'Error initializing subscription.');
    }
}

export async function cancelSubscription(userEmail, accessToken) {
    try {
        const { data } = await axios.post(
            '/user/cancel-subscription',
            { email: userEmail },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                }
            }
        );
        
        alert('Subscription canceled successfully!');
        console.log('Canceled:', data);
        window.location.href = '/dashboard/subscribe'; 

    } catch (error) {
        console.error('Error:', error.response?.data || error.message);
        if (error.response?.data?.error) {
            alert(error.response.data.error);
        } else {
            alert('An error occurred while cancelling subscription.');
        }
    }
}

